<template>
  <div class="text-left">
    <div v-if="mayEdit">
      <h4>Edit Address</h4>
      <mdb-input v-model="address.line1" id="initial-focus" label="Line 1"/>
      <mdb-input v-model="address.line2" label="Line 2"/>
      <mdb-input v-if="showAllLines" v-model="address.line3"/>
      <mdb-input v-if="showAllLines" v-model="address.line4"/>
      <mdb-input v-if="showCity" v-model="address.city" label="City"/>
      <gp-select v-if="showState" id="address-state"
                 :dataObj="address"
                 :label="stateLabel"
                 :possible-values="states"
                 :required="true" propertyName="state"/>
      <mdb-input v-if="showPostal" v-model="address.postal" :label="postalLabel"/>
      <mdb-btn :disabled="!formValid" color="success" icon="save" rounded size="sm" @click="$emit('complete')">Save</mdb-btn>
      <mdb-btn v-if="allowCancel" color="warning" icon="minus-circle" rounded size="sm" @click="$emit('cancel')">
        Cancel
      </mdb-btn>
    </div>
    <div v-if="!mayEdit">
      <div>{{address.line1}}</div>
      <div v-if="address.line2">{{address.line2}}</div>
      <div v-if="address.line3">{{address.line3}}</div>
      <div v-if="address.line4">{{address.line4}}</div>
      {{address.city}} {{address.stateCode}} {{address.postal}}
    </div>
  </div>
</template>

<script>
import {mdbBtn, mdbInput} from 'mdbvue';
import gpSelect from "./GPSelect";

export default {
  name: 'Address',
  components: {
    mdbInput,
    mdbBtn,
    gpSelect
  },
  data() {
    return {
      cityRequired : ["can","usa"],
      postalRequired:["can","usa"],
      stateRequired: ["can","usa"]
    }
  },
  props: {
    country: {
      type: String,
      default: null
    },
    address: {
      type: Object,
      default: null
    },
    states: {
      type: Array,
      default: null
    },
    allowCancel: {
      type: Boolean,
      default: false
    },
    mayEdit: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    stateLabel() {
      if (this.country == "can") return "Province"
      return "State"
    },
    postalLabel() {
      if (this.country == "usa") return "Zip Code"
      return "Postal Code"
    },
    showAllLines() {
      if (this.country == "can" || this.country == "usa") return false
      return true
    },
    showCity() {
      return true
    },
    showState() {
      if (this.country == "can" || this.country == "usa") return true
      return false
    },
    showPostal() {
      return true
    },
    formValid() {
      if ((this.address.country == "can" || this.address.country == "usa") && !this.address.state) return false
      if (!this.address.line1) return false
      if (!this.address.city && this.cityRequired.includes(this.country)) return false
      if (!this.address.state && this.stateRequired.includes(this.country)) return false
      if (!this.address.postal && this.postalRequired.includes(this.country)) return false

      return true
    }
  },
  mounted() {
    let el = document.getElementById("initial-focus")
    if (el) el.focus()
  },
  methods: {}
};
</script>

